import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\NotificationsController::update
* @see app/Http/Controllers/NotificationsController.php:105
* @route '/notifications/preferences'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

update.definition = {
    methods: ["post"],
    url: '/notifications/preferences',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\NotificationsController::update
* @see app/Http/Controllers/NotificationsController.php:105
* @route '/notifications/preferences'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\NotificationsController::update
* @see app/Http/Controllers/NotificationsController.php:105
* @route '/notifications/preferences'
*/
update.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\NotificationsController::update
* @see app/Http/Controllers/NotificationsController.php:105
* @route '/notifications/preferences'
*/
const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\NotificationsController::update
* @see app/Http/Controllers/NotificationsController.php:105
* @route '/notifications/preferences'
*/
updateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(options),
    method: 'post',
})

update.form = updateForm

const preferences = {
    update: Object.assign(update, update),
}

export default preferences